module.exports = __webpack_public_path__ + "static/media/2021winner-joanne-FR.2f6d82b3.jpg";